import { Component, OnInit, Input } from '@angular/core';
import { ProductService } from '../../../shared/services/product.service';
import { ActivatedRoute, Params } from '@angular/router';
import { ProductLineDetails } from './productlinedetails.model';
import { OPCConstant } from '../../opc.const';
import { OPCSettings } from '../../../shared/models/opcsettings.model';

@Component({
    selector: 'app-productlinedetails',
    templateUrl: './productlinedetails.component.html',
    styleUrls: ['./productlinedetails.component.css']
})
export class ProductLineDetailsComponent implements OnInit {
    productFamilyID: number;
    productLineDetails: ProductLineDetails;
    defaultImage: string;
    byPassFamilyName: string;
    productLineImgPath: string;
    opcSettings: OPCSettings = new OPCSettings();

    constructor(private _productService: ProductService, private _route: ActivatedRoute) {
        this.byPassFamilyName = OPCConstant.BYPASS_FAMILY;
  }

  getProductLines() {
      this._productService.getProductLineById(this.productFamilyID).subscribe(res => {
        this.productLineDetails = res;
        if (this.productLineDetails.productFamilyName === this.byPassFamilyName) {
          this.productLineDetails.productLines = [];
        }
      });
  }

    errorImage(event) {
        
    }
  ngOnInit() {
    this._route.params.subscribe(
            (params: Params) => {
                this.productFamilyID = params['pfid'];
                this.getProductLines();
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/opc/opc-app/productline/productlinedetails/productlinedetails.component.ts